import {
  initialState,
  Actions,
  State,
  DELETE_WELCOME_CONTENT_POST,
  DELETE_WELCOME_CONTENT_POST_SUCCESS,
  DELETE_WELCOME_CONTENT_POST_ERROR,
  RESET_DELETE_WELCOME_CONTENT_POST,
} from "../../types/welcome-content/delete-welcome-content-post";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_WELCOME_CONTENT_POST:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_WELCOME_CONTENT_POST_SUCCESS:
      return {
        ...state,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_WELCOME_CONTENT_POST_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_WELCOME_CONTENT_POST:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
